// extracted by mini-css-extract-plugin
module.exports = {"progress":"ListIncidents_progress__oKhcB"};